import { call, put, takeLatest } from 'redux-saga/effects';
import LegalActions from '../actions/LegalActions';
import LegalApi from '../apis/LegalApi';

function* getGuardianInfo(action) {
    try {
        const params = action.payload;
        const guardianData = yield call(LegalApi.get, params);
        yield put(LegalActions.getGuardianInfoSuccess(guardianData));
    } catch (e) {
        console.info('Failed to get guardian info: ', e);
        yield put(LegalActions.getGuardianInfoFailed(e));
    }
}

function* updateGuardianInfo(action) {
    try {
        const params = action.payload;
        const guardianData = yield call(LegalApi.update, params);
        yield put(LegalActions.updateGuardianInfoSuccess(guardianData));
    } catch (e) {
        console.info('Failed to update guardian info: ', e);
        yield put(LegalActions.getGuardianInfoFailed(e));
    }
}

function* LegalSaga() {
    yield takeLatest(LegalActions.TYPES.GET_GUARDIAN_INFO, getGuardianInfo);
    yield takeLatest(LegalActions.TYPES.UPDATE_GUARDIAN_INFO, updateGuardianInfo);
}

export default LegalSaga;
